module.exports = __webpack_public_path__ + "img/ditaro_logo.8cd1ffd9.png";